import React from "react";
import ReactApexChart from "react-apexcharts";

class LineChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      chartData: props.chartData || [],
      chartOptions: props.chartOptions || {},
    };
  }

  componentDidMount() {
    this.setState({
      chartData: this.props.chartData || [],
      chartOptions: this.props.chartOptions || {},
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.chartData !== this.props.chartData || prevProps.chartOptions !== this.props.chartOptions) {
      this.setState({
        chartData: this.props.chartData || [],
        chartOptions: this.props.chartOptions || {},
      });
    }
  }

  render() {
    const chartData = this.state.chartData || [];
    const chartOptions = this.state.chartOptions || {};
    const seriesLen = Array.isArray(chartData)
      ? chartData.reduce((acc, s) => acc + (Array.isArray(s?.data) ? s.data.length : 0), 0)
      : 0;
    const safeOptions = {
      ...chartOptions,
      chart: {
        ...(chartOptions.chart || {}),
        animations: {
          ...((chartOptions.chart && chartOptions.chart.animations) || {}),
          enabled: false,
        },
        toolbar: chartOptions.chart && chartOptions.chart.toolbar ? chartOptions.chart.toolbar : { show: false },
      },
      noData: {
        text: 'No data',
      },
    };
    const remountKey = seriesLen <= 1 ? `single-${seriesLen}-${chartData[0]?.data?.[0]?.x || 'none'}` : 'multi';
    if (seriesLen < 2) {
      return (
        <div style={{width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#A0AEC0', fontFamily: 'DM Sans', fontSize: 14}}>
          Snap! No chartable data yet
        </div>
      );
    }

    return (
      <ReactApexChart
        key={remountKey}
        options={safeOptions}
        series={chartData}
        type='area'
        width='100%'
        height='100%'
      />
    );
  }
}

export default LineChart;
